"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var NTDPatternsApp = /** @class */ (function (_super) {
    __extends(NTDPatternsApp, _super);
    function NTDPatternsApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedIndex: 0,
        };
        _this.selectIndex = function (index) {
            if (index > _this.props.patterns.length)
                index = 0;
            _this.setState({ selectedIndex: index });
        };
        _this.getSelectedBabyImage = function () {
            if (window.innerWidth <= 400 && _this.props.patterns[_this.state.selectedIndex].babyImageMobile) {
                return _this.props.patterns[_this.state.selectedIndex].babyImageMobile || '';
            }
            return _this.props.patterns[_this.state.selectedIndex].babyImage;
        };
        return _this;
    }
    NTDPatternsApp.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'cell large-4' },
                    React.createElement("div", { className: 'ntd-size-title-container text-left padding-5 medium-padding-left-0' },
                        React.createElement("h4", { className: 'h2', dangerouslySetInnerHTML: { __html: this.props.title || '' } }),
                        React.createElement("p", { className: 'font-lighter font-size-small' }, this.props.subtitle)),
                    React.createElement("div", { className: 'grid-x margin-bottom-5 ntd-patterns-swatch' }, this.props.patterns.map(function (p, index) {
                        return (React.createElement("div", { className: 'cell medium-12 small-6 margin-bottom-2 ', onClick: function () { return _this.selectIndex(index); }, key: index },
                            React.createElement("img", { className: (0, classnames_1.default)(_this.state.selectedIndex === index ? 'selected' : 'selected-not'), src: p.thumbnail })));
                    }))),
                React.createElement("div", { className: 'cell large-8' },
                    React.createElement("div", { className: 'ntd-patterns-baby-image' },
                        React.createElement("img", { src: this.getSelectedBabyImage() }))))));
    };
    return NTDPatternsApp;
}(React.Component));
exports.default = NTDPatternsApp;
